module.exports = __webpack_public_path__ + "media/images/canvas_logo-ebd9a9e2.svg";